import React, { useState, useEffect } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  TextField,
  Box,
  MenuItem,
  Select,
  Chip,
  Checkbox,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import axios from "axios";
import { BACKEND_BASE_URL } from "../../config";


const OrdinanceDialog = ({ open, onClose, ordinance, onSave }) => {

  const [isEditing, setIsEditing] = useState(false);
  const [editedOrdinance, setEditedOrdinance] = useState({ ...ordinance });
  const [categories, setCategories] = useState([]); // State for unique categories

  // Fetch unique categories from the backend
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${BACKEND_BASE_URL}/api/categories/`);
        setCategories(response.data); // Assuming response.data is an array of categories
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []); // Run once on mount

  // Handle input changes for text fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedOrdinance((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle category selection changes (multi-select)
  // const handleCategoryChange = (event) => {
  //   const value = event.target.value; // Array of selected category objects
  //   setEditedOrdinance((prev) => ({
  //     ...prev,
  //     categories: value, // Update with the full category object
  //   }));
  // };

  const handleCategoryChange = (event) => {
    const selectedIds = event.target.value; // Array of selected category IDs
    const selectedCategories = categories.filter(cat => selectedIds.includes(cat.id));
  
    setEditedOrdinance((prev) => ({
      ...prev,
      categories: selectedCategories, // Store selected categories as objects
    }));
  };
  
  


  // const handleRemoveCategory = (categoryIdToRemove) => {
  //   setEditedOrdinance((prev) => ({
  //     ...prev,
  //     categories: prev.categories.filter(
  //       (category) => category.id !== categoryIdToRemove,
  //     ), // Remove the category object by ID
  //   }));
  // };
  const handleRemoveCategory = (categoryIdToRemove) => {
    setEditedOrdinance((prev) => ({
      ...prev,
      categories: prev.categories.filter(category => category.id !== categoryIdToRemove), 
    }));
  };
  

  const toggleEditMode = () => {
    setIsEditing((prev) => !prev);
    if (!isEditing) {
      // Discard changes if toggling back to view mode
      setEditedOrdinance({ ...ordinance });
    }
  };

  const handleSave = () => {
    const flattenedOrdinance = {
      ...editedOrdinance,
      categories: Array.isArray(editedOrdinance.categories)
        ? editedOrdinance.categories.flat()
        : [],
    };
    onSave(flattenedOrdinance);
    setIsEditing(false);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          width: "50%",
          height: "60%",
          maxHeight: "90vh",
        },
      }}
    >
      <AppBar
        position="static"
        style={{ backgroundColor: "#0B194A", color: "white" }}
      >
        <Toolbar>
          <Typography variant="h6" style={{ flex: 1 }}>
            Summary Details
          </Typography>
          {isEditing ? (
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleSave}
              aria-label="save"
            >
              <SaveIcon />
            </IconButton>
          ) : (
            <IconButton
              edge="end"
              color="inherit"
              onClick={toggleEditMode}
              aria-label="edit"
            >
              <EditIcon />
            </IconButton>
          )}
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box style={{ padding: "20px" }}>

        {isEditing ? (

          <>
            
            <TextField
              label="Ordinance Name"
              name="name"
              value={editedOrdinance.name || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />

            {/* <Select
              label="Category"
              name="categories"
              value={editedOrdinance.categories || []} // Array of selected category objects
              onChange={handleCategoryChange}
              multiple
              fullWidth
              renderValue={(selected) => (
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {selected.map((item) => (
                    <Chip
                      key={item.id}
                      label={item.name || "Unknown"} // Display the name directly
                      onDelete={() => handleRemoveCategory(item.id)} // Remove category by ID
                    />
                  ))}
                </Box>
              )}
            >
              {categories.map((category) => (
                <MenuItem key={category.id} value={category}>
                  <Checkbox
                    checked={editedOrdinance.categories?.some(
                      (selected) => selected.id === category.id,
                    )}
                  />
                  {category.name}
                </MenuItem>
              ))}
            </Select> */}

<Select
  label="Category"
  name="categories"
  value={editedOrdinance.categories.map(cat => cat.id)} // Store as ID array
  onChange={handleCategoryChange}
  multiple
  fullWidth
  renderValue={(selectedIds) => (
    <Box display="flex" flexWrap="wrap" gap={1}>
      {editedOrdinance.categories.map((item) => (
        <Chip
          key={item.id}
          label={item.name || "Unknown"}
          onDelete={() => handleRemoveCategory(item.id)}
        />
      ))}
    </Box>
  )}
>
  {categories.map((category) => (
    <MenuItem key={category.id} value={category.id}> {/* Use ID here */}
      <Checkbox
        checked={editedOrdinance.categories.some(selected => selected.id === category.id)}
      />
      {category.name}
    </MenuItem>
  ))}
</Select>



            <TextField
              label="Short Summary"
              name="short_summary"
              value={editedOrdinance.short_summary || ""}
              onChange={handleInputChange}
              fullWidth
              multiline
              margin="normal"
            />
            <TextField
              label="Long Summary"
              name="long_summary"
              value={editedOrdinance.long_summary || ""}
              onChange={handleInputChange}
              fullWidth
              multiline
              margin="normal"
            />
          </>
        ) : (
          <>
            <Typography variant="h6" style={{ marginBottom: "10px" }}>
              {ordinance.num === "N/A" ? (
                <strong>{ordinance.name}</strong>
              ) : (
                <strong>
                  {ordinance.num}: {ordinance.name}
                </strong>
              )}
            </Typography>

            <Typography variant="body1" style={{ marginBottom: "10px" }}>
              <strong>Category:</strong>{" "}
              {ordinance.categories && ordinance.categories.length > 0
                ? ordinance.categories
                  .map((category) => category.name)
                  .join(", ")
                : "Uncategorized"}
            </Typography>
            <Typography variant="body1" style={{ marginBottom: "10px" }}>
              <strong>Short Summary:</strong> {ordinance.short_summary}
            </Typography>
            <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
              <strong>Long Summary:</strong> {ordinance.long_summary}
            </Typography>
          </>
        )}
      </Box>
    </Dialog>
  );
};

export default OrdinanceDialog;
